module.exports = __webpack_public_path__ + "static/media/hand-with-3-coin.639b7439.png";